import { render, staticRenderFns } from "./addons.vue?vue&type=template&id=46501c1e&scoped=true&"
import script from "./addons.vue?vue&type=script&lang=js&"
export * from "./addons.vue?vue&type=script&lang=js&"
import style0 from "./addons.vue?vue&type=style&index=0&id=46501c1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46501c1e",
  null
  
)

export default component.exports